import NepaliDate from 'nepali-date-converter';
import dayjs from 'dayjs';

export const getTodayDate = () => {
  const todayBsDate = new NepaliDate();

  const bsTodayDate = `${todayBsDate.getYear()}-${(todayBsDate.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${todayBsDate.getDate().toString().padStart(2, '0')}`;

  return bsTodayDate;
};

export const getAdFromBS = (value) => {
  const bsDate = new NepaliDate(value);
  return dayjs(bsDate.toJsDate());
};

// export const getAdFromBS = (bsDateStr) => {
//   const [year, month, day] = bsDateStr?.split('-').map(Number);
//   const ad = bs.toAD({ year, month, day });
//   return `${ad.year}-${String(ad.month).padStart(2, '0')}-${String(ad.day).padStart(2, '0')}`;
// };

export const getAdFromBSInYMD = (date) => {
  return `${date.$y}-${String(date.$M + 1).padStart(2, '0')}-${String(date.$D).padStart(2, '0')}`;
};

export const getBsFromAD = (value) => {
  try {
    if (!value) return null;
    const adDate = new Date(value);
    if (isNaN(adDate.getTime())) return null;
    const bsDate = NepaliDate.fromAD(adDate);
    return bsDate?.format?.('YYYY-MM-DD') || null;
  } catch {
    return null;
  }
};

export const getTodayDateAd = () => {
  const todayAdDate = new Date();

  const adTodayDate = `${todayAdDate.getFullYear()}-${(
    todayAdDate.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}-${todayAdDate.getDate().toString().padStart(2, '0')}`;

  return adTodayDate;
};

export const getCurrentTime = () => {
  const now = new Date();

  const time = `${now.getHours().toString().padStart(2, '0')}:${now
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

  return time;
};
